export default import.meta.ROLLDOWN_FILE_URL_YCGtArKB$SoHAcRX_5Kryg